import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  GOOGLE_REFRESH_CERTIFICATE_SLUGS,
  IBM_REFRESH_CERTIFICATE_SLUGS,
} from 'bundles/unified-description-page-common/utils/shouldShowNewAiSkillsBadge';

import _t from 'i18n!nls/unified-description-page-common';

const getSubheadingProfession = (slug?: string) => {
  if (slug === 'google-data-analytics') {
    return _t('data analytics');
  }
  if (slug === 'google-digital-marketing-ecommerce') {
    return _t('digital marketing & e-commerce');
  }
  if (slug === 'google-it-support') {
    return _t('IT support');
  }
  if (slug === 'google-project-management') {
    return _t('project management');
  }
  if (slug === 'google-ux-design') {
    return _t('UX design');
  }
  if (slug === 'google-cybersecurity') {
    return _t('cybersecurity');
  }

  return null;
};

export const getAiSkillsModalSubtitle = (slug?: string) => {
  if (slug && IBM_REFRESH_CERTIFICATE_SLUGS.includes(slug)) {
    return _t('Learn how to:');
  }
  if (slug && GOOGLE_REFRESH_CERTIFICATE_SLUGS.includes(slug)) {
    return (
      <FormattedMessage
        message={_t('This Professional Certificate includes 6 new videos on how to use AI in {profession}.')}
        profession={getSubheadingProfession(slug)}
      />
    );
  }

  if (slug === 'ai-essentials-google') {
    return _t(
      'This Specialization includes videos on how to use generative AI tools to boost productivity and innovation to:'
    );
  }
  if (slug === 'prompting-essentials-google') {
    return _t(
      "This Specialization includes videos on how to master the art of prompting to maximize AI's potential to:"
    );
  }
  return null;
};

export default getAiSkillsModalSubtitle;
